import connector from "./connector";
import RecordParams from "./RecordParams";
import Orders from "./Orders";
import Departments from "./Departments";
import Tires from "./Tires";
import Fcm from "./Fcm";
import Makes from "./Makes";
import Clients from "./Clients";

class Repository {
  connector = connector;
  RecordParams = RecordParams;
  Orders = Orders;
  Departments = Departments;
  Tires = Tires;
  Fcm = Fcm;
  Makes = Makes;
  Clients = Clients;
}

export default new Repository();
